import * as React from "react";
import "./Debug.scss";

interface DebugToggleProps {
  toggleDebug: () => void;
  isDebug: boolean;
}

const DebugToggle: React.SFC<DebugToggleProps> = ({ isDebug, toggleDebug }) => {
  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  return (
    <div className="Debug">
      <button onClick={toggleDebug}>
        debug:
        {" " + isDebug}
      </button>
    </div>
  );
};

export default DebugToggle;



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/DebugToggle.tsx